import { darken , lighten} from "@mui/material";
import lightOrdarkColor from "@check-light-or-dark/color";

const MuiIconButton = {
  styleOverrides: {
    root:{
        '&:hover': {
            backgroundColor: 'transparent',
        }
    },
  },
};

export default MuiIconButton;
